import React from 'react';
import PropTypes from 'prop-types';
import { NavLink as RouterLink } from 'react-router-dom';
// @mui
import { Box, Collapse, List, ListItemIcon, ListItemText } from '@mui/material';
//
import { StyledNavItem, StyledNavItemIcon, StyledSectionTitle } from './styles';
import i18n from '../../i18';
import { ArrowDownBoldIcon, ArrowUpBoldIcon } from '../../icons-lib';

// ----------------------------------------------------------------------

NavSection.propTypes = {
    data: PropTypes.array
};

export default function NavSection({ data = [], ...other }) {
    const [activeItem, setActiveItem] = React.useState(null);
    const handleItemClick = (titleKey) => {
        setActiveItem(activeItem === titleKey ? null : titleKey);
    };
    return (
        <Box {...other}>
            <List disablePadding sx={{ p: 1 }} >
                {data.map((section) => (
                    <React.Fragment key={section.title}>
                        <StyledSectionTitle>{section.title}</StyledSectionTitle>
                        {section.items.map((item) => (
                            <ListItem
                                key={item.titleKey}
                                item={item}
                                onClick={() => handleItemClick(item.titleKey)}
                                open={activeItem === item.titleKey}
                            />
                        ))}
                    </React.Fragment>
                ))}
            </List>
        </Box>
    );
}

// ----------------------------------------------------------------------
const NestedList = ({ data = [] }) => {
    return (
        <List component="div" disablePadding sx={{ pl: 4 }}>
            {data.map((item) => (
                <ListItem key={item.titleKey} item={item} isNested={true} />
            ))}
        </List>
    );
};
//----------------------------------------------------------------------

const ListItem = ({ item, isNested = false, onClick, open = false }) => {
    const { titleKey, path, icon, info, sublistData } = item;
    const translatedTitle = i18n.t(titleKey);

    const handleClick = () => {
        onClick && onClick();
    };
    const ListItemComponent = sublistData ? 'div' : RouterLink;
    const listItemProps = sublistData ? {} : { to: path };

    return (
        <>
            <StyledNavItem
                component={ListItemComponent}
                onClick={handleClick}
                sx={{
                    '&.active': {
                        color: 'text.primary',
                        bgcolor: 'action.selected',
                        fontWeight: 'fontWeightBold'
                    },
                    ...(!icon && { pl: 3 })
                }}
                {...listItemProps}
            >
                {icon && <StyledNavItemIcon>{icon}</StyledNavItemIcon>}

                <ListItemText disableTypography primary={translatedTitle} />
                {info && info}

                {sublistData && (
                    <ListItemIcon sx={{ justifyContent: 'center' }}>
                        {open ? <ArrowUpBoldIcon sx={{ fontSize: '1rem' }}/> : <ArrowDownBoldIcon sx={{ fontSize: '1rem' }}/>}
                    </ListItemIcon>
                )}
            </StyledNavItem>

            {sublistData && (
                <Collapse
                    in={open}
                    timeout={{ enter: 500, exit: 400 }}
                    unmountOnExit
                >
                    <NestedList data={sublistData} />
                </Collapse>
            )}
        </>
    );
};

ListItem.propTypes = {
    item: PropTypes.object.isRequired,
    isNested: PropTypes.bool,
    onClick: PropTypes.func,
    open: PropTypes.bool
};
